import { useContext, useEffect } from 'react';
import AutocompleteComponent from 'components/design-system/Autocomplete/Autocomplete';
import Heading from 'components/design-system/Heading/Heading';
import InputComponent from 'components/design-system/input/Input';
import LabelComponent from 'components/design-system/Label/Label';
import { Divider } from '@mui/material';
import { PERMISOS } from 'const/Permisos';
import { ObtieneListaDeEmpresas } from 'hooks/useServices';
import { AuthContext } from 'context';
import { SelectorDireccionContainer } from 'hooks/Selectors/hooks';

export const SucursalCampos = ({
  values,
  errors,
  touched,
  handleChange,
  setFieldValue,
  setFieldTouched,
  isSubmitting,
  isTienePermisos,
  codigoEmpresa,
  handleBlur,
  isSuperAdmin
}) => {
  const { sucursalNoAdministrada } = useContext(AuthContext);

  /**
   * Carga de sucursales para usuarios que administran sucursales
   */
  const asociados = !isSuperAdmin; // Indica que las empresas deben estar filtradas por las que el usuario tiene permiso en sus sucursales.
  const {
    empresas,
    isLoadingEmpresas,
    empresaSeleccionada,
    setEmpresaSeleccionada,
    cargarListaEmpresas
  } = ObtieneListaDeEmpresas({
    codigoEmpresaSeleccionado: values.empresa?.codigoEmpresa,
    isAsociados: asociados
  });

  useEffect(() => {
    // si un objto sucursalNoAdministrada esta vacio  se devuelve return
    if (!sucursalNoAdministrada.sucursal) return;

    if (isTienePermisos(PERMISOS.administracionSucursales)) {
      cargarListaEmpresas();
    } else {
      setFieldValue('empresa', sucursalNoAdministrada.sucursal.empresa);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cargarListaEmpresas]);

  useEffect(() => {
    //  console.log('empresaSeleccionada', empresaSeleccionada)
  }, [empresaSeleccionada]);

  return (
    <>
      <div className="grid grid-cols-12 gap-4 pb-6">
        <div className="col-span-12">
          <Heading type="h4" className="mb-0">
            Información de la sucursal
          </Heading>
        </div>
        {isTienePermisos(PERMISOS.administracionSucursales) && (
          <div className="col-span-12 xs:col-span-6  lg:col-span-4">
            <AutocompleteComponent
              id="empresa"
              name="empresa"
              accesor="nombreEmpresa"
              options={empresas}
              disabled={isLoadingEmpresas ? true : false}
              onChange={(ev, object, reason) => {
                if (reason === 'clear') {
                  setFieldValue('empresa', null);
                  setEmpresaSeleccionada(null);
                } else {
                  setEmpresaSeleccionada(object);
                  setFieldValue('empresa', object);
                }
              }}
              getOptionLabel={option => option.nombreEmpresa || ''}
              // value={empresas[0]}
              value={values.empresa}
              onBlur={() => setFieldTouched('empresa')}
            >
              <InputComponent
                fullWidth
                className="h-9"
                touched={touched.empresa ? true : false}
                estado={
                  errors.empresa
                    ? { tipo: 'error', mensaje: errors.empresa }
                    : null
                }
                label={<LabelComponent>Selecciona un negocio</LabelComponent>}
              />
            </AutocompleteComponent>
          </div>
        )}
        <div className="col-span-12 xs:col-span-6  lg:col-span-4">
          <InputComponent
            fullWidth
            name="nombreSucursal"
            value={values.nombreSucursal}
            onChange={handleChange}
            label={<LabelComponent>Nombre</LabelComponent>}
            onBlur={() => setFieldTouched('nombreSucursal')}
            touched={touched.nombreSucursal ? true : false}
            estado={
              errors.nombreSucursal
                ? { tipo: 'error', mensaje: errors.nombreSucursal }
                : null
            }
          />
        </div>
        <div className="col-span-12 xs:col-span-6 lg:col-span-4">
          <InputComponent
            fullWidth
            name="telefono"
            value={values.telefono}
            onBlur={() => setFieldTouched('telefono')}
            touched={touched.telefono ? true : false}
            label={<LabelComponent esOpcional>Teléfono</LabelComponent>}
            estado={
              errors.telefono
                ? { tipo: 'error', mensaje: errors.telefono }
                : null
            }
            onChange={event => {
              const value = event.target.value;
              if (/^\d*$/.test(value)) {
                setFieldValue('telefono', value || null); // establece el valor del campo
              }
            }}
          />
        </div>

        <div className="col-span-12 mt-3 mb-3">
          <Divider />
        </div>
        {/* Refactoring - direccion y mapa */}
        <SelectorDireccionContainer
          values={values}
          errors={errors}
          touched={touched}
          onChange={handleChange}
          handleBlur={handleBlur}
          setFieldTouched={setFieldTouched}
          setFieldValue={setFieldValue}
          isSubmitting={isSubmitting}
          esOpcionalRegion={true}
        />

        <div className="col-span-12 mt-3 mb-3">
          <Divider />
        </div>
      </div>
    </>
  );
};
